import React, {createRef, useEffect, useState} from 'react'
import {Modal, Button, Form} from 'antd'
import { connect } from 'react-redux'
import './index.scss'
import {InputSearchIco, ModalCloseIco} from '../../../modules/CustomIcons'
import InputField from "components/InputField";
import {getTemplatesByParams, Templates} from "../../services/Transfers/Templates";
import { secureLocalStorageGet } from '../../helpers'
import { useTranslation } from 'react-i18next'
import { log } from 'console'

const TemplateModal: React.FC<any> = (props: any) => {
  const {t} = useTranslation()
  const [ModalVisible, setModalVisible] = useState(props.visible || false)
  const [modalDataOriginal, setModalDataOriginal] = useState<Templates[]>()
  
  const [modalData, setModalData] = useState<Templates[]>()
  const [form] = Form.useForm();

  useEffect(() => {
    setModalVisible((old_value) => props.visible);

    getTemplates();

  }, [props.visible, props.data])

  const onClose = () => {
    props.onClose(old_value => false);

    setModalVisible(false)
  }

  const getTemplates = async () => {
    console.log('gettemplates')
    const data = await getTemplatesByParams(props.trnType);
    // let fav_templates = data?.filter(row => row.userName?.toLowerCase() === secureLocalStorageGet('username')?.toLowerCase())

    setModalData(old_data => data);
    setModalDataOriginal(old_data => data);
  }

  const filterTemplates = () => {
    const templateName=form.getFieldValue('templateName')?.toString()?.toLowerCase() || '',
          BENEFACC=form.getFieldValue('BENEFACC')?.toString()?.toLowerCase() || '',
          BENEFNAME=form.getFieldValue('BENEFNAME')?.toString()?.toLowerCase() || '',
          BENEFBANKNAME = form.getFieldValue('BENEFBANKNAME')?.toString()?.toLowerCase() || '';
    if (templateName.length >= 3 || BENEFACC.length >= 3 || BENEFNAME.length >= 3 || BENEFBANKNAME.length >= 3){

      const filtered_data=modalDataOriginal?.filter(row => {

            if (templateName){
              return row?.templateName?.toString().toLowerCase().includes(templateName);

            }else if(BENEFACC && row.trnData?.BENEFACC){
              return  row.trnData?.BENEFACC.toString().toLowerCase().includes(BENEFACC);

            } else if(BENEFNAME && row.trnData?.BENEFNAME){

              return  row.trnData?.BENEFNAME.toString().toLowerCase().includes(BENEFNAME)
            } else if(BENEFBANKNAME && row.trnData?.BENEFBANKNAME){
              return  row.trnData?.BENEFBANKNAME.toString().toLowerCase().includes(BENEFBANKNAME)
            }
          }
      );

      setModalData(old_data => filtered_data);

    }else{
      setModalData(old_data => modalDataOriginal);
    }
  }

  const fillCurrentForm = (selectedTemplate : Templates) => {
    let currentForm = props.currentForm;
    console.log("erq",selectedTemplate);
    currentForm.validateFields().then(success_input_list => {
    console.log("erqe",success_input_list);

      fillInputValues(success_input_list, currentForm, selectedTemplate)

    }).catch(err_input_list => {
    console.log("erqeq",err_input_list.values);

      let values= err_input_list.values

      fillInputValues(values, currentForm, selectedTemplate)

    });

    props.updateAfterTemplate(selectedTemplate);
    onClose();
  }

  const fillInputValues = (form_data : any, currentForm : any, selectedTemplate : Templates) => {
    for(let input_name in form_data){
      if(selectedTemplate.trnData[input_name] !== null) {
        if(input_name !== 'PMTCUSTID') {
          if (input_name === 'pdf_files') {
  const files = Array.isArray(selectedTemplate.trnData[input_name])
    ? selectedTemplate.trnData[input_name]
    : [selectedTemplate.trnData[input_name]].filter(Boolean);
  currentForm.setFieldsValue({
    [input_name]: selectedTemplate.trnData[input_name] ?? ''
  })
  // props.setFileList(files);
} else {
  currentForm.setFieldsValue({
    [input_name]: selectedTemplate.trnData[input_name] ?? ''
  });
}

        }
        console.log("ff",currentForm.getFieldValue("pdf_files"));
      }
    }
  }
  return (
    <>
      <Modal
          title={t("home.templates")}
          closeIcon={<ModalCloseIco />}
          centered={false}
          // style={{ left: 200 }}
          visible={ModalVisible}
          onOk={onClose}
          onCancel={onClose}
          width={900}
          className={`manage_faster_menus swift_modal template_list_popup_modal table_scroll_modal template_modal  template_modal_div ${props?.className} ${!modalDataOriginal ? 'manage_template_modal_empty' : ''} `}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
      >

        <Form
            layout="vertical"
            onFinish={(e) => {}}
            autoComplete="off"
            form={form}
        >
          {
            modalDataOriginal?.length > 0 ?
                <>
                  <table className={'table table-hover swift_table'}>
                    <thead>
                    <tr>
                      <th>
                        <InputField
                            labelItem={t("transfers.templateName")}
                            placeholder={t("transfers.atLeast3Char")}
                            className={'hide_placeholder_on_focus input-border-modal'}
                            name={'templateName'}
                            form={form}
                            suffix={<Button type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                            onKeyUp={filterTemplates}

                        />
                      </th>

                      <th>
                        <InputField
                            labelItem={t("newTransfer.beneficiaryAccount")}
                            placeholder={t("transfers.atLeast3Char")}
                            className={'hide_placeholder_on_focus input-border-modal'}
                            name={'BENEFACC'}
                            form={form}
                            suffix={<Button type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                            onKeyUp={filterTemplates}
                        />
                      </th>

                      <th>
                        <InputField
                            labelItem={t("newTransfer.beneficiaryName")}
                            placeholder={t("transfers.atLeast3Char")}
                            className={'hide_placeholder_on_focus input-border-modal'}
                            name={'BENEFNAME'}
                            allowLatin={true}
                            form={form}
                            suffix={<Button type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                            onKeyUp={filterTemplates}
                        />
                      </th>

                      <th>
                        <InputField
                            labelItem={t("newTransfer.beneficiaryBank")}
                            placeholder={t("transfers.atLeast3Char")}
                            className={'hide_placeholder_on_focus input-border-modal'}
                            name={'BENEFBANKNAME'}
                            allowLatin={true}
                            form={form}
                            suffix={<Button type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                            onKeyUp={filterTemplates}
                        />
                      </th>
                    </tr>
                    </thead>

                    <tbody>

                    {
                      modalData?.map((row, index) => {
                        return (
                            <tr onClick={() => fillCurrentForm(row)} className={index % 2 ? 'table-row-light' : 'table-row-dark'}>
                              <td style={{maxWidth:'170px'}}>{row.templateName}</td>
                              <td>{row.trnData.BENEFACC}</td>
                              <td>{row.trnData.BENEFNAME}</td>
                              <td>{row.trnData.BENEFBANKNAME}</td>
                              <td></td>
                            </tr>
                        )
                      })
                    }



                    </tbody>
                </table>

                  {
                      modalData?.length===0 && <p className={'no_result'} >Heç bir qeyd tapılmadı</p>
                  }
                </>


            : <p>{t("templates.noTemplate")}</p>
          }
        </Form>

      </Modal>
    </>
  )
}

export default connect(null, null)(TemplateModal)
